import { createActionTypes } from 'sdk/base';

export const sliceName = 'loginApi';
export const ActionTypes = createActionTypes([
    'UPDATE_USER_IN_CONTEXT',
    'UPDATE_LOGIN_ERROR'
]);

const config = {
    sliceName
};

export default config;
